import { httpClientPrivate } from "./axios";
import { accessToken } from "./token";

export const getNotification = async(page = 1, limit = 20)=>{
  const url = new URL('https://example.local');
  url.searchParams.append('page', page);
  url.searchParams.append('limitPerPage', limit);
  return await httpClientPrivate.get(`/notifications?${url.href.split('?')[1]}`, accessToken());
}